module.exports = __webpack_public_path__ + "img/beam.8900a1f3.svg";